<template>
    <b-modal ref="incidentsModal" id="incidentsModal"
      size="lg"
      header-bg-variant="primary"
      centered
      :hide-footer="false"
      @hide="cancel"
      :title="incident && incident.id ? 'Detalle de incidencia' : 'Crear incidencia'"
      @cancel="cancel"
      cancel-title="Cerrar"
      @ok="modalOk"
      ok-title="Seleccionar">

      <div v-show="errorText !== ''" class="alert alert-danger" role="alert" dismissible @dismised="errorText = ''">
      {{errorText}}
      </div>

      <b-form v-if="incident && incident.id">
        <b-row>
          <b-col cols="12" sm="6">
            <b-form-group
              horizontal
              :label-cols="4"
              label="Número">
              <b-form-input v-model="incidentDetail.id" :disabled="true"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6">
            <b-form-group
              horizontal
              :label-cols="4"
              label="Seller"
              :state="state.seller">
              <b-form-input v-model="incidentDetail.accountName" :disabled="true"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" :sm="!referenceIsSelected ? 12 : 6">
            <b-form-group
                horizontal
                :label-cols="!referenceIsSelected ? 2 : 4"
                label="Referencia">
                <b-form-input :value="typeOfReference" :disabled="true"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6">
            <b-form-input v-model="incident.reference" :disabled="true"></b-form-input>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tipo de incidencia"
              :invalid-feedback="!state.orderIncidenceType? 'Selecione un tipo de incidencia': ''"
              :state="state.orderIncidenceType">
              <b-form-select
                :options="orderIncidenceTypes"
                v-model="orderDetailAux.orderIncidenceType"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-show="incidentDetail.incidenceType === 'PRODUCT' || incidentDetail.incidenceType === 'SKU' || (orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType === 'Otra')">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Título"
              :invalid-feedback="invalidFeedBackTitle()"
              :state="state.title">
              <b-form-input
                v-model="incidentDetail.title"
                :disabled="incidentDetail.status === 'CLOSE' || incidentDetail.incidenceType === 'PRODUCT' || incidentDetail.incidenceType === 'SKU'">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Número de guía"
              :invalid-feedback="!state.numGuia? 'Número de guía inválido': ''"
              :state="state.numGuia">
              <b-form-input
                v-model="orderDetailAux.guideNumber"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tipo de envío"
              :invalid-feedback="!state.tipoEnvio? 'Tipo de envío inválido': ''"
              :state="state.tipoEnvio">
              <b-form-input
                v-model="orderDetailAux.shippingType"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tipo de paquetera"
              :invalid-feedback="!state.tipoPaquetera? 'Ingrese el tipo de paquetera': ''"
              :state="state.tipoPaquetera">
              <b-form-input
                v-model="orderDetailAux.packagerType"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="false && incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Estado de la guía"
              :invalid-feedback="!state.estadoGuia? 'Ingrese el estado de la guía': ''"
              :state="state.estadoGuia">
              <b-form-select
                :options="['Nueva', 'Entregada (bloqueada)']"
                v-model="orderDetailAux.guideStatus"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Estado del pedido"
              :invalid-feedback="!state.estadoPedido? 'Ingrese el estado del pedido': ''"
              :state="state.estadoPedido">
              <b-form-select
                :options="['', 'Enviado', 'Recibido']"
                v-model="orderDetailAux.orderStatus"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="URL del PDF de la guía"
              :invalid-feedback="!state.urlPdfGuia? 'Ingrese la URL del PDF de la guía': ''"
              :state="state.urlPdfGuia">
              <b-form-input
                v-model="orderDetailAux.urlPdfGuide"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="URL del ZPL de la guía"
              :invalid-feedback="!state.urlZplGuia? 'Ingrese la URL del ZPL de la guía': ''"
              :state="state.urlZplGuia">
              <b-form-input
                v-model="orderDetailAux.urlZplGuide"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="skuOrderList && skuOrderList.length > 0 && incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Sku(s)"
              :invalid-feedback="!state.orderSkus? 'Seleccione Sku(s)': ''"
              :state="state.orderSkus">
              <multiselect
                class="sku_autocomplete"
                @input="updateOrderDetail(orderDetailAux)"
                :options="skuOrderList"
                :multiple="true"
                :searchable="false"
                :internal-search="false"
                :clear-on-select="true"
                :close-on-select="true"
                :options-limit="300"
                :limit="100"
                :placeholder="$t('Ingrese el texto para buscar')"
                :disabled="incidentDetail.status === 'CLOSE'"
                :max-height="600"
                :selectLabel="$t('Enter para agregar Sku')"
                :show-no-results="true"
                :showPointer="true"
                :hideSelected="true"
                v-model="orderDetailAux.skus"
                ref="autocompleteSku">
                <span slot="noResult">No hay elementos para mostrar</span>
              </multiselect>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Origen"
              :invalid-feedback="!state.origin? 'Seleccione el origen': ''"
              :state="state.origin">
              <b-form-select
                :options="[{text: 'Tienda', value: 'T'}, {text: 'Seller', value: 'S'}, {text: 'Cliente', value: 'C'}]"
                v-model="orderDetailAux.source"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Destino"
              :invalid-feedback="!state.destination? 'Seleccione el destino': ''"
              :state="state.destination">
              <b-form-select
                :options="[{text: 'Tienda', value: 'T'}, {text: 'Seller', value: 'S'}, {text: 'Cliente', value: 'C'}]"
                v-model="orderDetailAux.destination"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tienda"
              :invalid-feedback="!state.store? 'Ingrese la tienda': ''"
              :state="state.store">
              <b-form-select
                :options="[{text: '', value: ''}, {text: '4263 (tienda ecommerce)', value: '4263'}]"
                v-model="orderDetailAux.store"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tipo de proceso"
              :invalid-feedback="!state.estadoPedido? 'Ingrese el tipo de proceso': ''"
              :state="state.proccessType">
              <b-form-select
                :options="[{text: '', value: ''}, {text: 'Devolución', value: 'Devolucion'}, {text: 'Reverse', value: 'Reverse'}, {text: 'Cancelación', value: 'Cancelacion'}, {text: 'Compra', value: 'Compra'}]"
                v-model="orderDetailAux.processType"
                :disabled="incidentDetail.status === 'CLOSE'">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Prioridad"
              :invalid-feedback="!state.priority? 'Selecione una prioridad': ''"
              :state="state.priority">
              <b-form-select
                :options="priorities"
                v-model="incidentDetail.priority"
                :disabled="true || incidentDetail.status === 'CLOSE' || (incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType === 'Otra') || incidentDetail.incidenceType === 'PRODUCT' || incidentDetail.incidenceType === 'SKU'">
              </b-form-select>
            </b-form-group>
          </b-col>

          <!-- <b-col cols="12" sm="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Título">
              <b-form-input
                v-model="incident.title"
                :disabled="true">
              </b-form-input>
            </b-form-group>
          </b-col> -->

          <hr class="w-100">
          <b-col cols="12" sm="12" v-if="incident.comments">
            <h6 class="mt-2 mb-3">Historial</h6>
            <article class="historial-comments">
                <div class="comment mb-2" v-for="(comments, index) in incident.comments" :key="index">
                    <p class="my-0"><strong>{{comments.author}}</strong></p>
                    <div class="message-blue">
                      <p class="message-content">{{comments.text}}</p>
                      <div class="message-timestamp-left"><i class="far fa-calendar-check calendar-history-incidents text-primary"></i>{{new Date(comments.date).toLocaleDateString(locale)}}</div>
                    </div>
                </div>
            </article>
          </b-col>
        </b-row>
      </b-form>

      <b-form v-else>

        <b-row>
          <b-col cols="12" sm="6">
            <b-form-group
              horizontal
              :label-cols="4"
              label="Número">
              <b-form-input :disabled="true"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6">
            <b-form-group
              horizontal
              :label-cols="4"
              label="Seller">
              <b-form-input :disabled="true" :value="referenceAux && referenceAux.accountName ? referenceAux.accountName : ''"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" :sm="hasSkuOptions ? 4 : 6">
            <b-form-group
                horizontal
                :label-cols="hasSkuOptions ? 6 : 4"
                label="Referencia"
                :invalid-feedback="!state.reference? 'Seleccione una referencia': ''"
                :state="state.reference">
                <b-form-select
                  @change="handleChange"
                  :options="references"
                  :disabled="incidentDetail.populate"
                  v-model="incidentDetail.incidenceType">
                </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12"
            :sm="hasSkuOptions ? 4 : 6"
            v-show="!incidentDetail.populate && (incidentDetail.incidenceType === 'PRODUCT' || incidentDetail.incidenceType === 'SKU')">
            <autocomplete
              :class="{
                'hide-pannel': filter.length === 1
              }"
              class="autocomplete__incidentModal"
              :maxElements="100"
              :selectLabel="'Enter para agregar al detalle'"
              :multiple="false"
              :provider="getSearchProducts"
              v-model="referenceAux">
            </autocomplete>
          </b-col>
          <b-col cols="12" sm="4" v-if="!incidentDetail.populate && hasSkuOptions">
            <b-form-group
                horizontal
                label="SKU"
                :state="state.reference">
                <b-form-select
                  :options="skuListOptions"
                  v-model="referenceSkuAux">
                </b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" v-show="!incidentDetail.populate && incidentDetail.incidenceType === 'ORDER'">
            <autocomplete
              class="autocomplete__incidentModal"
              :maxElements="100"
              :provider="getSearchOrders"
              :label="'id'"
              :selectLabel="'Enter para agregar la order'"
              :multiple="false"
              v-model="referenceAux">
            </autocomplete>
          </b-col>
          <b-col cols="12" sm="6" v-if="incidentDetail.populate">
            <b-form-input v-model="incident.reference" :disabled="true"></b-form-input>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tipo de incidencia"
              :invalid-feedback="!state.orderIncidenceType? 'Selecione un tipo de incidencia': ''"
              :state="state.orderIncidenceType">
              <b-form-select
                :options="orderIncidenceTypes"
                v-model="orderDetailAux.orderIncidenceType"
                :disabled="!referenceIsSelected">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-show="incidentDetail.incidenceType === 'PRODUCT' || incidentDetail.incidenceType === 'SKU' || (orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType === 'Otra')">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Título"
              :invalid-feedback="invalidFeedBackTitle()"
              :state="state.title">
              <b-form-input
                v-model="incidentDetail.title"
                :disabled="!referenceIsSelected">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Descripción"
              :invalid-feedback="!state.description? 'Descripción inválida': ''"
              :state="state.description">
              <b-form-textarea
                :disabled="!referenceIsSelected"
                v-model="comment.text"
                :rows="3"
                :max-rows="6">
              </b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Número de guía"
              :invalid-feedback="!state.numGuia? 'Número de guía inválido': ''"
              :state="state.numGuia">
              <b-form-input
                v-model="orderDetailAux.guideNumber"
                :disabled="!referenceIsSelected">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tipo de envío"
              :invalid-feedback="!state.tipoEnvio? 'Tipo de envío inválido': ''"
              :state="state.tipoEnvio">
              <b-form-input
                v-model="orderDetailAux.shippingType"
                :disabled="!referenceIsSelected">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tipo de paquetera"
              :invalid-feedback="!state.tipoPaquetera? 'Ingrese el tipo de paquetera': ''"
              :state="state.tipoPaquetera">
              <b-form-input
                v-model="orderDetailAux.packagerType"
                :disabled="!referenceIsSelected">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="false && incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Estado de la guía"
              :invalid-feedback="!state.estadoGuia? 'Ingrese el estado de la guía': ''"
              :state="state.estadoGuia">
              <b-form-select
                :options="['Nueva', 'Entregada (bloqueada)']"
                v-model="orderDetailAux.guideStatus"
                :disabled="!referenceIsSelected">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Estado del pedido"
              :invalid-feedback="!state.estadoPedido? 'Ingrese el estado del pedido': ''"
              :state="state.estadoPedido">
              <b-form-select
                :options="['', 'Enviado', 'Recibido']"
                v-model="orderDetailAux.orderStatus"
                :disabled="!referenceIsSelected">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="URL del PDF de la guía"
              :invalid-feedback="!state.urlPdfGuia? 'Ingrese la URL del PDF de la guía': ''"
              :state="state.urlPdfGuia">
              <b-form-input
                v-model="orderDetailAux.urlPdfGuide"
                :disabled="!referenceIsSelected">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="URL del ZPL de la guía"
              :invalid-feedback="!state.urlZplGuia? 'Ingrese la URL del ZPL de la guía': ''"
              :state="state.urlZplGuia">
              <b-form-input
                v-model="orderDetailAux.urlZplGuide"
                :disabled="!referenceIsSelected">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="skuOrderList && skuOrderList.length > 0 && incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Sku(s)"
              :invalid-feedback="!state.orderSkus? 'Seleccione Sku(s)': ''"
              :state="state.orderSkus">
              <multiselect
                class="sku_autocomplete"
                @input="updateOrderDetail(orderDetailAux)"
                :options="skuOrderList"
                :multiple="true"
                :searchable="false"
                :internal-search="false"
                :clear-on-select="true"
                :close-on-select="true"
                :options-limit="300"
                :limit="100"
                :placeholder="$t('Ingrese el texto para buscar')"
                :disabled="false"
                :max-height="600"
                :selectLabel="$t('Enter para agregar Sku')"
                :show-no-results="true"
                :showPointer="true"
                :hideSelected="true"
                v-model="orderDetailAux.skus"
                ref="autocompleteSku">
                <span slot="noResult">No hay elementos para mostrar</span>
              </multiselect>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Origen"
              :invalid-feedback="!state.origin? 'Seleccione el origen': ''"
              :state="state.origin">
              <b-form-select
                :options="[{text: 'Tienda', value: 'T'}, {text: 'Seller', value: 'S'}, {text: 'Cliente', value: 'C'}]"
                v-model="orderDetailAux.source"
                :disabled="!referenceIsSelected">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Destino"
              :invalid-feedback="!state.destination? 'Seleccione el destino': ''"
              :state="state.destination">
              <b-form-select
                :options="[{text: 'Tienda', value: 'T'}, {text: 'Seller', value: 'S'}, {text: 'Cliente', value: 'C'}]"
                v-model="orderDetailAux.destination"
                :disabled="!referenceIsSelected">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tienda"
              :invalid-feedback="!state.store? 'Ingrese la tienda': ''"
              :state="state.store">
              <b-form-select
                :options="[{text: '', value: ''}, {text: '4263 (tienda ecommerce)', value: '4263'}]"
                v-model="orderDetailAux.store"
                :disabled="!referenceIsSelected">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" v-if="incidentDetail.incidenceType === 'ORDER' && orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType !== 'Otra'">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Tipo de proceso"
              :invalid-feedback="!state.estadoPedido? 'Ingrese el tipo de proceso': ''"
              :state="state.proccessType">
              <b-form-select
                :options="[{text: '', value: ''}, {text: 'Devolución', value: 'Devolucion'}, {text: 'Reverse', value: 'Reverse'}, {text: 'Cancelación', value: 'Cancelacion'}, {text: 'Compra', value: 'Compra'}]"
                v-model="orderDetailAux.processType"
                :disabled="!referenceIsSelected">
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Prioridad"
              :invalid-feedback="!state.priority? 'Selecione una prioridad': ''"
              :state="state.priority">
              <b-form-select
                :options="priorities"
                v-model="incidentDetail.priority"
                :disabled="!referenceIsSelected">
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>

      <div slot="modal-footer" class="w-100">
          <div class="w-100">
            <b-button variant="secondary" class="float-right mx-1" @click="cancel()">{{incident === null ? 'Cancelar' : 'Cerrar'}}</b-button>
            <b-button v-show="incident === null || incidentDetail.populate" :disabled="disableSave()" variant="primary" class="float-right mx-1" @click="modalOk">Crear</b-button>
            <b-button
              v-show="incident !== null && incidentDetail.status !== 'CLOSE' && !incidentDetail.populate"
              class="mb-2 mx-1 float-right"
              variant="primary"
              @click.stop="markAsSolved">
              Marcar como solucionado
            </b-button>
            <b-button
              v-show="incident && incidentDetail.status !== 'CLOSE' && !incidentDetail.populate && incidentDetail.payload"
              class="mb-2 mx-1 float-right"
              variant="primary"
              :disabled="disableSave()"
              @click.stop="updateIncidentDetail">
              Actualizar
            </b-button>
          </div>
      </div>
    </b-modal>
</template>

<script>
import { ProductServiceMixim } from '@/mixims/ProductServiceMixim'
import { OrdersServiceMixim } from '@/mixims/OrdersServiceMixim'
import { IncidentsServices } from '@/mixims/IncidentsServices'
import { ValidationsMixim } from '@/mixims/ValidationsMixim'
import autocomplete from '@/components/common/vue-autocomplete'
import Multiselect from 'vue-multiselect'
import appConfig from '@/config/applicationConfig.js'

export default {
  name: 'incidents-modal',
  mixins: [ValidationsMixim, ProductServiceMixim, OrdersServiceMixim, IncidentsServices],
  props: ['show', 'incident', 'references', 'priorities'],
  components: {
    autocomplete,
    Multiselect
  },
  data () {
    return {
      locale: appConfig.LOCALE,
      titlelimit: 30,
      errorText: '',
      filter: '',
      seller: '',
      incidentDetail: {
        creationDate: '',
        id: '',
        incidenceType: '',
        priority: '',
        reference: '',
        title: '',
        status: '',
        updateDate: '',
        payload: ''
      },
      orderIncidenceTypes: ['Devolución (DV)',
        'Cambio físico (CF)',
        'Venta (VT)',
        'Recolección (RC)',
        'Reenvío (RV)',
        'Otra'
      ],
      comment: {
        author: '',
        date: '',
        text: ''
      },
      referenceAux: null,
      referenceSkuAux: null,
      orderDetailAux: {},
      componentKey: 0,
      skuOrderList: [],
      orderDetailSkus: false
    }
  },
  watch: {
    /* incident () {
      if (this.incident && this.incident.id) {
        this.incidentDetail = {...this.incident}
        if (this.incidentDetail.incidenceType === 'ORDER' && this.incidentDetail.payload) this.orderDetailAux = JSON.parse(this.incidentDetail.payload)
      }
    }, */

    filter () {
      if (this.filter !== undefined && (typeof this.filter === 'object' && this.filter.length)) {
        this.seller = this.filter[0].accountName
      } else if (!this.filter.length) {
        this.seller = null
      }
    },
    show () {
      this.skuOrderList = []
      this.orderDetailAux = { destination: null }
      if ((this.incident && this.incident.id) || (this.incident && this.incident.populate)) {
        this.incidentDetail = {...this.incident}
        if (this.incidentDetail.incidenceType === 'ORDER' && this.incidentDetail.payload) {
          let payload = JSON.parse(this.incidentDetail.payload)
          this.orderDetailAux = payload
        }
      }
      if ((this.incident && this.incident.populate && this.incident.incidenceType === 'ORDER') || (this.incident && this.incident.id && this.incident.incidenceType === 'ORDER')) {
        this._getOrderDetails(this.incident.reference)
      }
      this.show ? this.$refs.incidentsModal.show() : this.$refs.incidentsModal.hide()
    },
    referenceAux () {
      if (this.referenceAux === null) return
      if (this.referenceSkuAux && !this.hasSkuOptions) return
      this.updateReference(this.referenceAux)
    },
    referenceSkuAux () {
      this.updateReferenceSku(this.referenceSkuAux)
    },
    orderDetailAux: {
      handler () {
        this.updateOrderDetail(this.orderDetailAux)
      },
      deep: true
    },
    orderIncidenceType () {
      this.updateOrderDetail(this.orderDetailAux)
    },
    guideStatus () {
      this.updateOrderDetail(this.orderDetailAux)
    },
    incidentDetail: {
      handler () {
        if ((this.incidentDetail.incidenceType === 'SKU' || this.incidentDetail.incidenceType === 'PRODUCT') && this.incidentDetail.payload) {
          let payload = JSON.parse(this.incidentDetail.payload)
          if (payload.orderIncidenceType !== 'Otra') {
            this.incidentDetail.title = ''
          }
          this.incidentDetail.payload = null
        }
        this.invalidFeedBackTitle()
        this.getReferenceState()
        this.getTitleState()
      },
      deep: true
    }
  },
  computed: {
    typeOfReference () {
      if (this.incident) {
        let reference = this.incident.incidenceType
        return this.references.filter(referenceItem => { return referenceItem.value === reference })[0].text
      }

      return ''
    },
    typeOfPriority () {
      if (this.incident && this.incident.priority) {
        let priority = this.incident.priority
        return this.priorities.filter(priorityItem => { return priorityItem.value === priority })[0].text
      }

      return ''
    },
    userText () {
      return this.$store.state.user_data.firstName + ' ' + this.$store.state.user_data.lastName
    },
    state () {
      return {
        reference: this.getReferenceState(),
        priority: !this.isEmptyData(this.incidentDetail.priority),
        title: this.getTitleState(),
        description: this.incidentDetail.id ? true : this.isValidTextArea(this.comment.text, true, 1000),
        orderIncidenceType: this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' ? !this.isEmptyData(this.orderDetailAux.orderIncidenceType) : true,
        numGuia: this.validateOrderDetailGuide(this.orderDetailAux.guideNumber),
        tipoEnvio: this.validateOrderTipoEnvio(this.orderDetailAux.shippingType),
        tipoPaquetera: this.validateOrderTipoPaquetera(this.orderDetailAux.packagerType),
        // estadoGuia: this.validateOrderDetail(this.orderDetailAux.guideStatus),
        estadoPedido: true,
        urlPdfGuia: this.validateOrderPdfGuia(this.orderDetailAux.urlPdfGuide),
        urlZplGuia: this.validateOrderZplGuia(this.orderDetailAux.urlZplGuide),
        orderSkus: this.validateOrderDetailSkus(this.orderDetailAux.skus),
        origin: this.validateOrderDetail(this.orderDetailAux.source),
        destination: this.validateOrderDetail(this.orderDetailAux.destination),
        store: true,
        proccessType: true
      }
    },
    referenceIsSelected () {
      return (this.incidentDetail.incidenceType !== '')
    },
    hasSkuOptions () {
      return this.incidentDetail.incidenceType === 'SKU' && this.skuListOptions.length > 0
    },
    skuListOptions () {
      if (this.referenceAux !== null) {
        return this.referenceAux.skus.map(sku => { return {text: sku.skuName, value: sku.id} })
      }

      return []
    },
    orderIncidenceType () {
      if (this.orderDetailAux && this.orderDetailAux.orderIncidenceType) {
        return this.orderDetailAux.orderIncidenceType
      }
    },
    guideStatus () {
      if (this.orderDetailAux && this.orderDetailAux.guideStatus) {
        return this.orderDetailAux.guideStatus
      }
    }
  },
  methods: {
    invalidFeedBackTitle () {
      return !this.state.title ? this.incidentDetail.title !== undefined && this.incidentDetail.title !== null && this.incidentDetail.title.length > this.titlelimit ? 'El máximo número de caracteres es: ' + this.titlelimit : 'Ingrese un título' : ''
    },
    disableSave () {
      return Object.values(this.state).includes(false)
    },
    resetModal () {
      this.errorText = ''
      this.referenceAux = null
      this.referenceSkuAux = null
      this.orderDetailAux = { destination: null }
      this.skuOrderList = []
      // if (this.incidentDetail.populate) this.$router.push(this.$route.path).catch(() => {})
      if (this.incidentDetail.populate) this.$router.push(this.$route.path)
      this.incidentDetail = {}
      this.comment = {}
    },
    cancel () {
      this.resetModal()
      this.$emit('update:show', false)
    },
    modalOk () {
      let thisDate = new Date()

      this.comment.date = thisDate
      this.incidentDetail.updateDate = thisDate

      let incidentFinal = {
        ...this.incidentDetail,
        comments: [this.comment],
        creationDate: thisDate,
        status: 'OPEN'
      }

      this.createIncident(incidentFinal).then(
        response => {
          this.$emit('saved', response.data)
        }
      ).catch(
        error => {
          this.errorText = error.body.message || 'Ocurrió un error al crear la incidencia'
        }
      )
    },
    updateIncidentDetail () {
      this.updateIncident(this.incidentDetail.id, this.incidentDetail).then(
        response => {
          this.$emit('updated', response.data)
          this.cancel()
        }
      ).catch(
        error => {
          this.errorText = error.body.message || 'Ocurrió un error al actualizar la incidencia'
        }
      )
    },
    markAsSolved () {
      this.$emit('markAsSolved', this.incident)
    },
    updateReference (referenceAux) {
      if (this.incidentDetail.incidenceType === 'ORDER' || this.incidentDetail.incidenceType === 'PRODUCT') this.incidentDetail.reference = referenceAux.id
      // if (this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && !this.incident && referenceAux && referenceAux.shippingData) this.orderDetailAux.destination = `${referenceAux.shippingData.address.street} ${referenceAux.shippingData.address.number}, ${referenceAux.shippingData.address.city}, ${referenceAux.shippingData.address.state}, ${referenceAux.shippingData.address.country}`
      if (this.orderDetailAux && this.incidentDetail.incidenceType === 'ORDER' && !this.incident && this.referenceAux && this.referenceAux.id) {
        this.orderDetailAux.skus = []
        this._getOrderDetails(this.referenceAux.id)
      }
    },
    updateOrderDetail (orderDetail) {
      if (!orderDetail) return

      this.incidentDetail.payload = JSON.stringify(orderDetail)

      if (this.incidentDetail.incidenceType === 'ORDER') {
        if (orderDetail.orderIncidenceType === 'Otra') {
          this.incidentDetail.title = ''
        } else {
          this.incidentDetail.title = orderDetail.orderIncidenceType || ''
        }
      }

      this.validateOrderDetailSkus()
    },
    getReferenceState () {
      if (this.incidentDetail.populate) return !this.isEmptyData(this.incidentDetail.reference)
      if (!this.incidentDetail.id && (this.incidentDetail.incidenceType === 'ORDER' || this.incidentDetail.incidenceType === 'PRODUCT')) return !this.isEmptyData(this.referenceAux)
      if (this.incident && this.incident.id) return !this.isEmptyData(this.incident.reference)
      return !this.isEmptyData(this.referenceSkuAux)
    },
    getTitleState () {
      const requiresTitle =
        this.incidentDetail.incidenceType === 'PRODUCT' ||
        this.incidentDetail.incidenceType === 'SKU' ||
        (this.incidentDetail.incidenceType === 'ORDER' &&
        this.orderDetailAux &&
        this.orderDetailAux.orderIncidenceType === 'Otra')

      return requiresTitle
        ? this.isValidText(this.incidentDetail.title, true, this.titlelimit)
        : true
    },
    validateOrderDetail (field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? !this.isEmptyData(field) : true
    },
    validateOrderDetailGuide (field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, false, 100) : true
    },
    validateOrderTipoEnvio (field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, true, 10) : true
    },
    validateOrderTipoPaquetera (field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, false, 100) : true
    },
    validateOrderPdfGuia (field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, false, 500) : true
    },
    validateOrderZplGuia (field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, false, 500) : true
    },
    validateOrderDetailSkus () {
      if (this.orderDetailAux && this.orderDetailAux.skus && this.orderDetailAux.skus.length > 0) {
        this.orderDetailSkus = true
      } else {
        this.orderDetailSkus = false
      }
      return this.orderDetailAux && this.orderDetailAux.skus && this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' ? this.orderDetailSkus : true
    },
    handleChange () {
      this.referenceSkuAux = null
      this.referenceAux = null
      this.incidentDetail.reference = null
      this.orderDetailAux = { destination: null }
    },
    _getOrderDetails (orderId) {
      this.getOrderDetails(orderId).then(
        (response) => {
          let orderDetail = response.body
          this.skuOrderList = []
          orderDetail.items.map(item => this.skuOrderList.push(item.id))
          // if (orderDetail.shippingData && orderDetail.shippingData.address && this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.incidentDetail.populate) this.orderDetailAux.destination = `${orderDetail.shippingData.address.street} ${orderDetail.shippingData.address.number}, ${orderDetail.shippingData.address.city}, ${orderDetail.shippingData.address.state}, ${orderDetail.shippingData.address.country}`
        }
      )
    }
  }
}
</script>

<style lang="scss">
  .autocomplete__incidentModal{
    &.hide-pannel{
      // border: 4px solid red !important;
      .multiselect{
        .multiselect__content-wrapper{
          display: none !important;
          opacity: 0 !important;
          .multiselect__content{
            display: none !important;
          }
        }
      }
    }
    .multiselect{
      min-height: 41px !important;
      .multiselect__tags {
          min-height: 35px !important;
          border-radius: 0px !important;
          border-color: #e3e8ec;
          padding: 5px 40px 0 8px;
      }
    }
  }

  .sku_autocomplete {
    .multiselect__input {
      width: 0 !important;
      position: absolute;
    }
    .multiselect{
      min-height: 41px !important;
      .multiselect__tags {
          border-radius: 0px !important;
          border-color: #e3e8ec;
      }
    }
  }

  .sku_autocomplete {
    .multiselect__input {
      width: 0 !important;
      position: absolute;
    }
    .multiselect__single {
      display: none;
    }
    .multiselect__select {
      height: 40px;
    }
    min-height: 41px !important;
      .multiselect__tags {
        border-radius: 0px !important;
        border-color: #e3e8ec;
      }
  }

  .calendar-history-incidents {
    margin-right:3px; 
    margin-top:3px;
  }
  // message styles 
  .message-blue {
    position: relative;
    margin-left: 20px;
    margin-bottom: 10px;
    padding: 5px 10px 10px 10px;
    background-color: #eff9ff;
    display: inline-block;
    min-width: 200px;
    min-height: 50px;
    text-align: left;
    border: 1px solid #97C6E3;
    border-radius: 10px;
  }

  .message-content {
      padding: 0;
  }

  .message-timestamp-left {
      position: absolute;
      font-weight: 300;
      bottom: 5px;
      left: 10px;
  }

  .message-blue:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-top: 15px solid #eff9ff;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      top: 0;
      left: -15px;
  }

  .message-blue:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-top: 17px solid #97C6E3;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
      top: -1px;
      left: -17px;
  }
</style>




// WEBPACK FOOTER //
// src/components/incidents/incidentsModal.vue